module.exports = __webpack_public_path__ + "static/media/event.40d2717a.jpg";